module.exports= {
	mini_satcom: require("./mini_satcom.svg"),
	
};